// Mirrors server-side ImportParseResult / commit body shapes.
// Source of truth: apps/nos/server/src/controllers/me/flavor/formulas/import/_shared.ts

export type ImportParseInsertableItem = {
  compoundId: number;
  name: string;
  cas: string | null;
  sourceText: string;
  suggestedAmount: number | null;
  suggestedUnit: string | null;
  confidence: 'deterministic' | 'llm';
};

export type ImportParseMixtureItem = {
  foodId: number;
  name: string;
  sourceText: string;
};

export type ImportParseUnidentifiedItem = {
  sourceText: string;
  parsedIdentifiers: {
    name?: string;
    cas?: string;
    inchikey?: string;
    fema?: string;
  };
};

export type ImportParseResult = {
  parseId: string;
  insertable:   ImportParseInsertableItem[];
  mixtures:     ImportParseMixtureItem[];
  unidentified: ImportParseUnidentifiedItem[];
};

export type ImportCommitMode = 'insert' | 'replace';

export const IMPORT_AMOUNT_UNITS = ['ppm', 'ppb', 'ppt', 'mol%', 'mg', 'g', 'kg', 'μL', 'mL', 'L'] as const;
export type ImportAmountUnit = (typeof IMPORT_AMOUNT_UNITS)[number];

export type ImportSelection = {
  compoundId:  number;
  amountValue: number;
  amountUnit:  ImportAmountUnit;
};

export type ParseSource =
  | { kind: 'paste'; text: string }
  | { kind: 'file';  fileUploadId: string };
